import { get } from 'lodash'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'

import { BASE_URL as searchURL } from 'search'
import System from 'system'

import Block from '../ui/Block'
import LoaderProgress from '../ui/LoaderProgress'
import { postListFetch, postListFetchCanceled } from './PostListActions'
import Post from './posts/Post'

import './PostList.css'

class PostList extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      lastPage: 0,
      page: 0,
      updating: false,
    }
    this.scrollTop = 0

    const {
      owner,
      posts: { typeId },
      type,
    } = this.props
    if (typeId !== owner.id) {
      this.props.postListFetch(type, owner.id, 1, this.props.wall)
    }
  }

  static getDerivedStateFromProps(props, state) {
    const {
      posts: { loaded, pagination },
    } = props

    if (loaded && !pagination) {
      return {
        lastPage: 0,
        page: 0,
        updating: false,
      }
    }
    const page = get(pagination, 'current_page', state.page)

    return {
      lastPage: get(pagination, 'last_page', page + 1),
      page,
      updating: !loaded,
    }
  }

  componentWillUnmount() {
    if (this.state.updating) {
      this.props.postListFetchCanceled()
    }
  }

  onLoadMorePosts = () => {
    const {
      owner,
      posts: { pagination },
      type,
    } = this.props
    const ownerId = owner.id

    if (this.state.updating) {
      return
    }

    let page = 1
    if (pagination && pagination.current_page && pagination.current_page < pagination.last_page) {
      page = pagination.current_page + 1
    }

    if (page !== this.state.page) {
      this.props.postListFetch(type, ownerId, page, this.props.wall)
    }

    this.setState({
      lastPage: get(pagination, 'last_page', page + 1),
      page,
      updating: true,
    })
  }

  onRefreshPosts = () => {
    const { owner, type } = this.props

    if (this.state.updating) {
      return
    }

    this.props.postListFetch(type, owner.id, 1, this.props.wall)

    this.setState({
      lastPage: 0,
      page: 0,
      updating: true,
    })
  }

  render() {
    const {
      active,
      isAdmin,
      owner,
      posts: { data },
      type,
      wall,
    } = this.props
    const { lastPage, page, updating } = this.state
    const {
      auth: { usr },
    } = this.props

    const ownerId = owner.id
    const viewerId = usr ? usr.id : null

    return (
      <div className="PostList">
        {!updating && !data.length && ownerId === viewerId && (
          <div
            style={{
              clear: 'both',
              padding: '5px',
              textAlign: 'center',
            }}
          >
            <sup>
              <Icon name="quote left" size="small" />
            </sup>
            Aún no tienes posts.
            <sup>
              <Icon name="quote right" size="small" />
            </sup>
            <div>
              Haz clic en el botón&nbsp;
              <Icon
                circular
                color="green"
                inverted
                name="search"
                onClick={() => System.history.push(searchURL)}
                size="small"
              />
              &nbsp;para seguir instituciones.
            </div>
          </div>
        )}
        {!!data.length && (
          <InfiniteScroll
            className="flex flex-col gap-1"
            dataLength={data.length}
            disabled={!active || lastPage === 1}
            endMessage={
              <span className="PostList__pull">
                <sup>
                  <Icon name="quote left" size="small" />
                </sup>
                Siempre puedes compartir algo más.
                <sup>
                  <Icon name="quote right" size="small" />
                </sup>
              </span>
            }
            hasMore={active && page < lastPage}
            initialScrollY={this.scrollTop}
            loader={
              <Block className="PostList__load">
                <LoaderProgress content="Buscando posts..." positive />
              </Block>
            }
            loadingMore={updating}
            next={this.onLoadMorePosts}
            onScroll={() => {
              this.scrollTop = window.pageYOffset
            }}
            pullDownToRefreshContent={
              <div className="PostList__pull">
                <Icon name="pointing down" size="large" />
                Hala para refrescar el listado.
              </div>
            }
            refreshFunction={this.onRefreshPosts}
            releaseToRefreshContent={
              <div className="PostList__pull">
                <Icon name="pointing up" size="large" />
                Libera para refrescar el listado.
              </div>
            }
          >
            {data.map((post) => (
              <Post key={post.id} date={post.created_at} isAdmin={isAdmin} post={post} type={type} wall={wall} />
            ))}
          </InfiniteScroll>
        )}
      </div>
    )
  }
}

PostList.propTypes = {
  auth: PropTypes.object.isRequired,
  owner: PropTypes.object.isRequired,
  postListFetch: PropTypes.func.isRequired,
  postListFetchCanceled: PropTypes.func.isRequired,
  posts: PropTypes.object.isRequired,
  type: PropTypes.oneOf([
    'advertising',
    'institution',
    'sports_soccer_match',
    'sports_soccer_team',
    'sports_tournament',
    'stats',
    'user',
  ]).isRequired,

  active: PropTypes.bool,
  isAdmin: PropTypes.bool,
  wall: PropTypes.bool,
}

PostList.defaultProps = {
  active: true,
  isAdmin: false,
  wall: false,
}

export default connect(
  ({ auth, posts }) => ({
    auth,
    posts,
  }),
  { postListFetch, postListFetchCanceled },
)(PostList)
